export enum AffiliateLinkCategory {
  DEFAULT = "default",
  TC = "tc",
  CASINO = "casino",
  SPORTS = "sports",
  BONUS = "bonus",
  COOKIE_POPUP = "cookie_popup",
  REVIEW_POPUP = "review_popup",
  TOURNAMENTS = "tournaments"
}

export function getAffiliateLinkCategories(): string[] {
  return Object.values(AffiliateLinkCategory);
}